import { Button } from '../ui/Button.tsx';

/**
 * Inline per-panel load failure: message + retry, no toast (DESIGN.md
 * §7 single-channel errors — async load failures never double-report).
 * Shared by the usage-analytics pages (epic #897 PR 6); labels arrive
 * translated from the caller.
 */
interface Props {
  readonly message: string;
  readonly retryLabel: string;
  readonly onRetry: () => void;
  readonly testId?: string;
}

export function PanelError({ message, retryLabel, onRetry, testId }: Props): JSX.Element {
  return (
    <div role="alert" data-testid={testId} className="flex flex-wrap items-center gap-3">
      <p className="m-0 text-dense text-bad">{message}</p>
      <Button variant="ghost" size="sm" onClick={onRetry}>
        {retryLabel}
      </Button>
    </div>
  );
}
